import type {SketchCircleObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SingleTargetRelation} from '../SingleTargetRelation';

let count = 0;
const MIN_DIAMETER = 1e-8;

/**
 * 判断对象是否为圆直径关系。
 * @param value 待判断对象。
 * @returns 是否为圆直径关系。
 */
export function isCircleDiameterConstraint(value: object): value is CircleDiameterConstraint {
    return Reflect.get(value, 'isCircleDiameterConstraint') === true;
}

/**
 * 圆直径关系定义。
 *
 * 锁定值按直径保存，参数公式负责转换为半径方程。
 */
export class CircleDiameterConstraint extends SingleTargetRelation<SketchCircleObject> {
    /** 运行时类型标记。 */
    public readonly isCircleDiameterConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Diameter;
    /** 锁定直径。 */
    private lockedDiameter: number | null = null;

    /**
     * @param diameter 锁定直径；未提供时保持未锁定。
     */
    public constructor(diameter?: number) {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
        if (typeof diameter === 'number') {
            this.setLockedDiameter(diameter);
        }
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '直径';
    }

    /** @returns 锁定直径；未锁定返回 null。 */
    public getLockedDiameter(): number | null {
        return this.lockedDiameter;
    }

    /**
     * 设置锁定直径。
     * @param diameter 新直径。
     */
    public setLockedDiameter(diameter: number): void {
        if (!Number.isFinite(diameter) || diameter <= MIN_DIAMETER) {
            return;
        }
        this.lockedDiameter = diameter;
    }
}
